<template>
  <div>
    <a-month-picker placeholder="选择月份" @change="onChange"> </a-month-picker>
  </div>
</template>
<script>
export default {
  data() {
    return {}
  },
  methods: {
    onChange(date, dateString) {
      this.$emit('change', dateString)
    }
  }
}
</script>
